import MailConfiguration from './MailConfiguration';

export default MailConfiguration;